document.addEventListener('DOMContentLoaded', function () {
  const faqsSection = document.querySelector('.faqs-section');

  if (!faqsSection) return;

  const tabElements = faqsSection.querySelectorAll('[data-tab-list-item]');

  // Function to remove active class from all tab titles
  function removeActiveFromAllTabs() {
    tabElements.forEach((tab) => {
      const tabTitle = tab.querySelector('.faqs-section__tab-title');
      if (tabTitle) {
        tabTitle.classList.remove('active');
      }
    });
  }

  // Function to add active class to a specific tab title
  function setActiveTab(tabElement) {
    removeActiveFromAllTabs();
    const tabTitle = tabElement.querySelector('.faqs-section__tab-title');
    if (tabTitle) {
      tabTitle.classList.add('active');
    }
  }

  // Add click event listeners to each tab
  tabElements.forEach((tab) => {
    tab.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent default anchor behavior

      const tabReference = this.getAttribute('data-tab-list-item');
      const targetId = `#faq-section-${tabReference}`;
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        // Scroll to the FAQ group with smooth animation
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        // Set active class to clicked tab
        setActiveTab(this);
      }
    });
  });

  // Check for hash in URL first
  const hash = window.location.hash;
  if (hash) {
    const targetTab = faqsSection.querySelector(`[href="${hash}"]`);
    if (targetTab) {
      const tabElement = targetTab.closest('[data-tab-list-item]');
      if (tabElement) {
        // Set active class to the target tab from hash
        setActiveTab(tabElement);
      }
    }
  } else {
    // If no hash, set active class to the first tab by default
    if (tabElements.length > 0) {
      setActiveTab(tabElements[0]);
    }
  }
});
